import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as svc from "../../api/accountHeadService";

export const fetchAccountHeads = createAsyncThunk("accountHeads/fetchAll", async (params) => {
  const res = await svc.getAccountHeads(params);
  return res.data;
});

export const createAccountHeadThunk = createAsyncThunk("accountHeads/create", async (data) => {
  const res = await svc.createAccountHead(data);
  return res.data;
});

export const updateAccountHeadThunk = createAsyncThunk("accountHeads/update", async ({ id, data }) => {
  const res = await svc.updateAccountHead(id, data);
  return res.data;
});

export const deleteAccountHeadThunk = createAsyncThunk("accountHeads/delete", async (id) => {
  await svc.deleteAccountHead(id);
  return id;
});

const accountHeadSlice = createSlice({
  name: "accountHeads",
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccountHeads.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchAccountHeads.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchAccountHeads.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createAccountHeadThunk.fulfilled, (state, action) => { state.list.push(action.payload); })
      .addCase(updateAccountHeadThunk.fulfilled, (state, action) => {
        const id = action.payload.accountID || action.payload.id;
        const idx = state.list.findIndex((a) => (a.accountID || a.id) === id);
        if (idx !== -1) state.list[idx] = action.payload;
      })
      .addCase(deleteAccountHeadThunk.fulfilled, (state, action) => {
        state.list = state.list.filter((a) => (a.accountID || a.id) !== action.payload);
      });
  },
});

export default accountHeadSlice.reducer;
